import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center h-full"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col justify-center items-center h-full"
}
const _hoisted_3 = { class: "text-red-500 mb-4" }
const _hoisted_4 = {
  key: 2,
  class: "flex flex-col h-full justify-between"
}
const _hoisted_5 = { class: "space-y-6" }
const _hoisted_6 = { class: "flex items-center justify-between border-b border-secondary pb-2" }
const _hoisted_7 = { class: "text-2xl font-bold text-gray-800" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs text-white bg-secondary opacity-80 px-2 py-1 rounded font-bold"
}
const _hoisted_9 = { class: "space-y-3" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "col-span-1 text-gray-500" }
const _hoisted_12 = { class: "col-span-5 font-medium" }
const _hoisted_13 = { class: "col-span-3" }
const _hoisted_14 = { class: "col-span-3" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "py-8 text-center text-gray-500"
}
const _hoisted_17 = { class: "mt-auto" }

import { useMortality } from "@/composables/tasks/mortality-check/useMortality";
import { useNotifications } from "@/composables/useNotifications";
import FooterActions from "@/components/v2/Tasks/Vaccination/Buttons/ActionButtons/FooterActions.vue";
import { ref } from "vue";
import { Tank } from "@/types/v2";
import { TasksService } from "@/services/v2/tasks";


export default /*@__PURE__*/_defineComponent({
  __name: 'OverviewView',
  setup(__props) {

const { activeTask, tanks, navigateToTankView, isLoading, error, initTask } = useMortality();
const { showTaskCompletionSuccess, showError } = useNotifications();
const commentsModal = ref(false);
const instructionsModal = ref(false);

const toggleCommentsModal = () => commentsModal.value = !commentsModal.value;
const toggleInstructionsModal = () => instructionsModal.value = !instructionsModal.value;
const handleTankClick = (tank: Tank) => navigateToTankView(tank.key);

const handleCompleteTask = async () => {
    if (!activeTask.value) return;

    try {
        await TasksService.finishTask(activeTask.value);
        showTaskCompletionSuccess(activeTask.value.title);
    } catch (error) {
        console.error('Error completing task:', error);
        showError("Task Completion Failed", "Failed to complete task. Please try again.");
    }
};

const handleRetry = () => {
    initTask();
};

return (_ctx: any,_cache: any) => {
  return (_unref(isLoading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-primary" }, null, -1)
      ])))
    : (_unref(error))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(error)), 1),
          _createElementVNode("button", {
            onClick: handleRetry,
            class: "px-4 py-2 bg-primary text-white rounded"
          }, "Retry")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h1", _hoisted_7, _toDisplayString(_unref(activeTask)?.title) + " - Overview", 1),
              (_unref(activeTask)?.studyTitle)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(activeTask).studyTitle), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"grid grid-cols-12 px-4 py-2 bg-gray-50 rounded-t font-medium text-sm text-gray-600\"><div class=\"col-span-1\">#</div><div class=\"col-span-5\">Tank</div><div class=\"col-span-3\">Status</div><div class=\"col-span-3\">Actions</div></div>", 1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tanks), (tank, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: tank.key,
                  class: "grid grid-cols-12 px-4 py-3 bg-white border border-gray-100 rounded hover:bg-gray-50 cursor-pointer",
                  onClick: ($event: any) => (handleTankClick(tank))
                }, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(index + 1), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(tank.label), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["px-2 py-1 text-xs font-semibold rounded-full", {
                'bg-green-100 text-green-800': tank.status === 'completed',
                'bg-yellow-100 text-yellow-800': tank.status === 'pending'
              }])
                    }, _toDisplayString(tank.status === 'completed' ? 'Completed' : 'Pending'), 3)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      class: "px-3 py-1 text-sm text-white bg-primary rounded hover:bg-primary-dark",
                      onClick: _withModifiers(($event: any) => (handleTankClick(tank)), ["stop"])
                    }, " View Details ", 8, _hoisted_15)
                  ])
                ], 8, _hoisted_10))
              }), 128)),
              (_unref(tanks).length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, " No tanks available for this task. "))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(FooterActions, null, {
              start: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: toggleInstructionsModal,
                  class: "w-full"
                }, " Instructions ")
              ]),
              middle: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: toggleCommentsModal,
                  class: "w-full"
                }, " Comment ")
              ]),
              end: _withCtx(() => [
                _createElementVNode("button", {
                  onClick: handleCompleteTask,
                  class: "w-full"
                }, " Complete task ")
              ]),
              _: 1
            })
          ])
        ]))
}
}

})